import { Culture } from "./culture.model";

export class CultureScore {
    public culture_id : number;
    public score : number;
    public score2 : number;
    public culture : Culture;
}